import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-[#3B0A12] text-[#FAF5F0] mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="font-serif font-bold text-2xl">Mana<span className="text-[#C59B27]">Jodi</span></div>
          <p className="text-[#C59B27] text-sm mt-1">Your Jodi. Your Journey.</p>
          <p className="text-xs text-[#D8B4B9] mt-4 leading-relaxed">A trusted matrimonial platform combining tradition, modern search and AI compatibility.</p>
        </div>
        <FooterCol title="Platform" links={[["How It Works", "/how-it-works"], ["Pricing", "/pricing"], ["Telugu Matrimony", "/telugu-matrimony"], ["Indian Matrimony", "/indian-matrimony"]]} />
        <FooterCol title="Resources" links={[["Find a Life Partner", "/life-partner"], ["Matrimony Guide", "/matrimony-guide"], ["Blog", "/blog"], ["Help & Safety", "/safety"]]} />
        <FooterCol title="Company" links={[["About", "/about"], ["FAQ", "/faq"], ["Contact Us", "/contact"], ["Terms & Privacy", "/legal/terms"]]} />
      </div>
      <div className="border-t border-[#781826]/50">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#D8B4B9]">
          <span>© {new Date().getFullYear()} ManaJodi. All rights reserved.</span>
          <span className="font-medium">ManaJodi is a product of <a href="https://vs-solutions.in" target="_blank" rel="noopener" className="text-[#E2C382] hover:text-white underline">Vijay Software Solutions Pvt Ltd</a></span>
        </div>
        <div className="max-w-7xl mx-auto px-4 pb-4 text-center text-[11px] text-[#8A6D71]">Support: info@vs-solutions.org</div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="text-sm font-semibold text-[#E2C382] mb-3">{title}</h4>
      <ul className="space-y-2">
        {links.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-sm text-[#D8B4B9] hover:text-white transition">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
